import { colors, radius, elevation, spacing, transitions, zIndex, glassEffect } from '../../utils/designSystem';

export function Modal({
  open,
  onClose,
  children,
  title = "",
  showDefaultAction = true,
  variant = "default",
  size = "md"
}) {
  if (!open) return null;

  // Size variants
  const sizes = {
    sm: { maxWidth: '28rem', padding: spacing[4] },
    md: { maxWidth: '36rem', padding: spacing[5] },
    lg: { maxWidth: '48rem', padding: spacing[6] },
    xl: { maxWidth: '64rem', padding: spacing[8] },
  };

  // Variant styles
  const variants = {
    default: {
      background: colors.neutral.white,
      boxShadow: elevation['2xl'],
    },
    glass: {
      ...glassEffect(0.95),
      boxShadow: elevation['2xl'],
    },
    alert: {
      background: colors.neutral.white,
      boxShadow: elevation['2xl'],
      border: `2px solid ${colors.error.main}`,
    },
    success: {
      background: colors.neutral.white,
      boxShadow: elevation['2xl'],
      border: `2px solid ${colors.success.main}`,
    },
  };

  const currentVariant = variants[variant] || variants.default;
  const currentSize = sizes[size] || sizes.md;

  const backdropStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: zIndex.modalBackdrop,
    display: 'grid',
    placeItems: 'center',
    background: 'rgba(0, 0, 0, 0.4)',
    padding: spacing[4],
  };

  const modalStyle = {
    maxWidth: currentSize.maxWidth,
    width: '100%',
    borderRadius: radius.modal,
    background: currentVariant.background,
    backdropFilter: currentVariant.backdropFilter,
    WebkitBackdropFilter: currentVariant.backdropFilter,
    padding: currentSize.padding,
    boxShadow: currentVariant.boxShadow,
    border: currentVariant.border || 'none',
    maxHeight: 'calc(100svh - 2rem)',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    WebkitOverflowScrolling: 'touch',
    zIndex: zIndex.modal,
  };

  const titleStyle = {
    marginBottom: spacing[2],
    fontSize: '1.125rem',
    fontWeight: '700',
    color: colors.neutral.black,
  };

  const contentStyle = {
    color: colors.neutral[800],
  };

  const buttonStyle = {
    marginTop: spacing[4],
    borderRadius: radius.sm,
    padding: `${spacing[1]} ${spacing[3]}`,
    fontSize: '0.875rem',
    fontWeight: '600',
    border: `1px solid ${colors.neutral[300]}`,
    background: colors.neutral.white,
    color: colors.neutral[700],
    cursor: 'pointer',
    transition: transitions.default,
  };

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div
        style={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {title && <div style={titleStyle}>{title}</div>}
        <div style={contentStyle}>{children}</div>
        {showDefaultAction && (
          <div style={{ marginTop: spacing[4], display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={onClose}
              style={buttonStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = colors.neutral[50];
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = colors.neutral.white;
              }}
            >
              Got it
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
